export default class TeammemberList {
    constructor($el) {
        this.$el = $el;
        this.$members = this.$el.querySelectorAll('[data-open-modal-team]');

        this.openModal = this.openModal.bind(this);

        this.$members.forEach((member) => {
            member.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal(member);
            });
        })
    }

    openModal(member) {
        let hashId = member.dataset.openModalTeam;
        let modalContainer = document.querySelector(`[data-modal-container="${hashId}"]`);
        let modal = modalContainer.querySelector("[data-modal]");

        modalContainer.classList.add('modal__container--open');
        modal.classList.add('modal--open');
    }
}